export default __webpack_public_path__ + "static/media/crypto.7d8a1c52.svg";